import { PaymentRequest } from '@/modules/allies/paymentRequests/types/PaymentRequest.ts'

export interface PaymentRequestState {
  isLoading: boolean
  paymentRequests: PaymentRequest[]
  paymentRequest: PaymentRequest | null
  editId: string | null
  filters: string
  isLoadingAction: boolean
  openProcesarPagoModal: boolean
  selectedRows: PaymentRequest[]
  selectionResetKey: number
}

export const initialState: PaymentRequestState = {
  isLoading: false,
  paymentRequests: [],
  paymentRequest: null,
  openProcesarPagoModal: false,
  editId: null,
  filters: `?limit=100`,
  isLoadingAction: false,
  selectedRows: [],
  selectionResetKey: 0
}
